/**
 * Owner: Masa Bayu
 * File: bka-manuscript-types.ts
 * Date:Time: 2026-09-22 17:29
 * Description: BKA source artifact/job types — manuscript + pdf kinds · adapter flags.
 */
/** Feature flag — Manuscript UI/integration + adapter ship under QX-DOC-04 AUTH. */
export const BKA_MANUSCRIPT_FEATURE_FLAG = Object.freeze({
    id: 'bka.manuscript.import_ui',
    defaultEnabledInProduction: false,
    wave: 'manuscript',
    path: 'manuscript',
    adapterShipped: true,
    adapterGate: 'QX-DOC-04',
    doc03Undisturbed: true,
});
/** Feature flag — PDF UI/integration + PDFAdapter ship under PDF BUILD AUTH. */
export const BKA_PDF_FEATURE_FLAG = Object.freeze({
    id: 'bka.pdf.import_ui',
    defaultEnabledInProduction: false,
    wave: 'pdf',
    path: 'pdf',
    adapterShipped: true,
    adapterGate: 'PDF-BUILD-AUTH',
    irGate: 'QX-DOC-04',
    doc03Undisturbed: true,
});
export const BKA_SOURCE_KINDS = ['manuscript', 'pdf'];
export const BKA_MANUSCRIPT_AUTHORIZED_KIND = 'manuscript';
export const BKA_PDF_AUTHORIZED_KIND = 'pdf';
export const BKA_AUTHORIZED_SOURCE_KINDS = Object.freeze([
    'manuscript',
    'pdf',
]);
export const BKA_ARTIFACT_INTAKE_STATES = [
    'staged',
    'bound',
    'failed',
];
export const BKA_INTEGRATION_JOB_STATUSES = [
    'queued',
    'running',
    'succeeded',
    'failed',
    'blocked_adapter_unavailable',
];
//# sourceMappingURL=bka-manuscript-types.js.map